import React from 'react';
import { DataWidgetFiltersInputContextProps } from './DataWidgetFiltersInput';

export const DataWidgetFiltersInputContext =
  React.createContext<DataWidgetFiltersInputContextProps>(undefined);

export function useDataWidgetFiltersInputState() {
  const context = React.useContext(DataWidgetFiltersInputContext);

  if (!context) {
    throw new Error(
      'Hook `useDataWidgetFiltersInputState` may only be used within <DataWidgetFiltersInputProvider />.'
    );
  }

  return context;
}
